import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import {Box, Container} from '@mui/material';
import Navbar from './components/Navbar';
import Homepage from './components/Homepage';
import Lineup from './components/Lineup';
import Dashboard from './admin/Dashboard';
import {useCallback, useEffect, useState} from "react";
import axios from "axios";
import AdminNavbar from "./admin/AdminNavbar";
import ManageQueue from "./admin/ManageQueue";
import Login from './components/Login';
import Cookies from 'js-cookie';

function App() {
  const [queue, setQueue] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(Cookies.get('isLoggedIn') === 'true');
  const [groupId, setGroupId] = useState(null);

  useEffect(() => {
        axios.get('/api/queues/nextQueue')
            .then(response => {
                setQueue(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

  //grab group id if exists
  useEffect(() => {
       const groupIdStorage = localStorage.getItem('groupId');

       //if group id found in storage, then set to groupID
       if (groupIdStorage) {
           setGroupId(JSON.parse(groupIdStorage));
       }
  }, []);

  //Render proper navbar
    function RenderNavbar() {
        const location = useLocation();
        if (location.pathname.startsWith('/staff')) {
            return <AdminNavbar />;
        }
        return <Navbar />;
    }

    // Protected Route Component
    function ProtectedRoute({ children }) {
        const location = useLocation();
        if (!isLoggedIn) {
            return <Navigate to="/login" state={{ from: location }} />;
        }
        return children;
    }

  return (
      <>
          {RenderNavbar()}
          <Box>
            <Routes>
                <Route path="/" element={<Homepage queue={queue} groupId={groupId}/>} />
                <Route path="/line-up" element={<Lineup queue={queue} groupId={groupId} setGroupId={setGroupId}/>} />
                <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
                <Route path="/staff" element={<ProtectedRoute> <Dashboard/> </ProtectedRoute>} />
                <Route path="/staff/active/:queueId" element={<ProtectedRoute> <ManageQueue /> </ProtectedRoute>} />
            </Routes>
          </Box>
      </>
  );
}

export default App;
